import { useState } from "react";
import Reveal from "@/components/base/Reveal";
import { faqs } from "@/mocks/siteData";

export default function Faq() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);

  return (
    <section id="faq" className="bg-background-50 py-16 md:py-24 scroll-mt-20">
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14">
          <Reveal className="lg:col-span-4">
            <div className="lg:sticky lg:top-28">
              <span className="inline-flex items-center gap-2 text-xs font-medium tracking-widest text-primary-600 uppercase">
                <span className="w-6 h-px bg-primary-400"></span>
                常见问题
              </span>
              <h2 className="mt-4 font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-snug">
                关于观看方式，你可能想问
              </h2>
              <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
                这些问题来自实际浏览中容易卡住的环节。点开任意一条即可查看说明，再次点击可收起，所有内容都已在本页中。
              </p>
              <div className="mt-6 inline-flex items-center gap-2 px-4 py-2.5 rounded-lg bg-background-100 border border-background-200 text-sm text-foreground-600">
                <i className="ri-question-answer-line text-lg text-primary-600" aria-hidden="true"></i>
                共 {faqs.length} 条常见问题
              </div>
            </div>
          </Reveal>

          <div className="lg:col-span-8">
            <div className="space-y-3">
              {faqs.map((item, idx) => {
                const isOpen = openIdx === idx;
                return (
                  <Reveal key={item.q} delay={Math.min(idx, 5) * 50}>
                    <div
                      className={`rounded-lg border transition-colors ${
                        isOpen ? "border-primary-300 bg-background-100" : "border-background-200 bg-background-100"
                      }`}
                    >
                      <button
                        onClick={() => setOpenIdx(isOpen ? null : idx)}
                        aria-expanded={isOpen}
                        className="w-full flex items-center justify-between gap-4 px-5 py-4 md:px-6 md:py-5 text-left cursor-pointer"
                      >
                        <span className="flex items-start gap-3">
                          <span
                            className={`w-6 h-6 flex items-center justify-center rounded-md text-xs font-medium shrink-0 mt-0.5 ${
                              isOpen ? "bg-primary-500 text-background-50" : "bg-secondary-100 text-secondary-800"
                            }`}
                          >
                            Q
                          </span>
                          <span className="font-heading text-base md:text-lg font-semibold text-foreground-950">
                            {item.q}
                          </span>
                        </span>
                        <i
                          className={`shrink-0 text-xl transition-transform ${
                            isOpen ? "ri-subtract-line text-primary-600 rotate-180" : "ri-add-line text-foreground-400"
                          }`}
                          aria-hidden="true"
                        ></i>
                      </button>
                      <div
                        className="grid transition-all duration-300 ease-out"
                        style={{ gridTemplateRows: isOpen ? "1fr" : "0fr" }}
                      >
                        <div className="overflow-hidden">
                          <p className="px-5 pb-5 md:px-6 md:pb-6 pl-14 md:pl-[3.75rem] text-sm md:text-base text-foreground-600 leading-relaxed">
                            {item.a}
                          </p>
                        </div>
                      </div>
                    </div>
                  </Reveal>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}